import { z } from "zod";

import { defaultItem, defaultUrl, transformerMdContentParam, itemSchema, urlSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const projectSchema = itemSchema.extend({
  name: z.string().min(1),
  description: z.string(),
  date: z.string(),
  summary: transformerMdContentParam,
  keywords: z.array(z.string()).default([]),
  url: urlSchema,
});

export const minimalProjectSchema = projectSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Project = z.infer<typeof projectSchema>;
export type MinimalProject = z.infer<typeof minimalProjectSchema>;

// Defaults
export const defaultProject: Project = {
  ...defaultItem,
  name: "",
  description: "",
  date: "",
  summary: "",
  keywords: [],
  url: defaultUrl,
};

export const deminimalizeProject = (project: MinimalProject): Project => {
  return {
    ...defaultProject,
    ...project,
    id: createId(),
  };
};
